export default "__VITE_ASSET__BLvTxaRK__"